// extracted by mini-css-extract-plugin
export var fadeInOut = "_2z-3";
export var icon = "_2z-4";
export var savedIndicator = "_2z-2";
export var savingIndicator = "_2z-0";
export var spin = "_2z-1";